import { RadialProgress } from '@/src/components/radial-progress'
import { cn } from '@/src/utils/styles'

export const QuoteRemainingTime = ({
  refetchInterval,
  isPaused,
  className,
}: {
  refetchInterval: number
  isPaused: boolean
  className?: string
}) => {
  return (
    <div
      className={cn(
        'absolute -inset-px z-10',
        'transition-opacity duration-300 opacity-100 group-hover:opacity-0 group-hover:invisible group-hover:sr-only',
        '[transform:rotateY(-180deg)]',
        className,
      )}
    >
      <RadialProgress
        animated={!isPaused}
        duration={refetchInterval / 1000}
        strokeWidth={1}
        circleClasses='text-transparent'
        progressClasses={cn('text-tertiary', {
          'opacity-0': isPaused,
        })}
      />
    </div>
  )
}
